// removed by extract-text-webpack-plugin
module.exports = {"root":"_3a1jV","image":"_t29Bv"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Parallax/Parallax.scss
// module id = 1595
// module chunks = 8